import React, { useEffect }from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import ProjectBusPriorityList from 'components/Agile/projectBusPriority/projectBusPriorityList';
import AppModuleHeader from 'components/AppModuleHeader/index';
import ProjectBusPriorityAdd from 'components/Agile/projectBusPriority/projectBusPriorityMaintenance/projectBusPriorityAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';
import {
    fetchProjectBusPrioritys,
    getAllProjectBusPriority,
    getUnselectedAllProjectBusPriority,
    handleProjectBusPriorityRequestClose,
    showProjectBusPriorityLoader,
    onAddProjectBusPriority,
    onFilterSelectedProjectBusPriority,
    onFilterProjectBusPriorityOptionSelect,
    onToggleProjectBusPriorityDrawer,
    updateSearchProjectBusPriority,
    filterProjectBusPriority,
} from 'actions/projectBusPriority';

const filterOptions = [
    {
        id: 1,
        name: 'All projectBusPrioritys',
        icon: 'zmdi-menu'
    }, {

        id: 2,
        name: 'Starred projectBusPrioritys',
        icon: 'zmdi-star'
    }
];

const Component = () => {
    const dispatch = useDispatch();
    const width = useSelector(state => state.settings.width);

    const loader = useSelector(state => state.projectBusPrioritys.loader);
    const alertMessage = useSelector(state => state.projectBusPrioritys.alertMessage);
    const showMessage = useSelector(state => state.projectBusPrioritys.showMessage);
    const noContentFoundMessage = useSelector(state => state.projectBusPrioritys.noContentFoundMessage);
    const drawerState = useSelector(state => state.projectBusPrioritys.drawerState);
    const projectBusPriority = useSelector(state => state.projectBusPrioritys.projectBusPriority);
    const searchProjectBusPriority = useSelector(state => state.projectBusPrioritys.searchProjectBusPriority);
    const projectBusPriorityList = useSelector(state => state.projectBusPrioritys.projectBusPriorityList);
    const selectedProjectBusPrioritys = useSelector(state => state.projectBusPrioritys.selectedProjectBusPrioritys);
    const addProjectBusPriorityState = useSelector(state => state.projectBusPrioritys.addProjectBusPriorityState);
    const selectedSectionId = useSelector(state => state.projectBusPrioritys.selectedSectionId);

    useEffect(() => {
        dispatch(showProjectBusPriorityLoader());
        dispatch(fetchProjectBusPrioritys());
    }, []);

    const onAllProjectBusPrioritySelect = () => {
        const selectAll = selectedProjectBusPrioritys < projectBusPriorityList.length;
        if (selectAll) {
            dispatch(getAllProjectBusPriority());
        } else {
            dispatch(getUnselectedAllProjectBusPriority());
        }
    };

    const updatingSearchProjectBusPriority = (evt) => {
        dispatch(updateSearchProjectBusPriority(evt.target.value));
        dispatch(filterProjectBusPriority(evt.target.value));
    };

    const projectBusPriorityRequestClose = () => {
        dispatch(handleProjectBusPriorityRequestClose());
    };

    const projectBusPrioritySideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.projectBusPrioritys" /></span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={() => dispatch(onAddProjectBusPriority())}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="projectBusPriority.addProjectBusPriority" /></span>
                        </Button>
                    </div>
                    <div className="module-side-nav">
                        <ul className="module-nav">
                            {filterOptions.map(option => <li key={option.id} className="nav-item">
                                <a href="javascript:void(0)"
                                    className={option.id === selectedSectionId ? 'active' : ''} 
                                    onClick={() => dispatch(onFilterProjectBusPriorityOptionSelect(option))}>
                                    <i className={`zmdi ${option.icon}`} />
                                    <span>{option.name}</span>
                                </a>
                            </li>
                            )}

                        </ul>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;
    };

    return (
        <div className="app-wrapper">
            <div className="app-module animated slideInUpTiny animation-duration-3">
                <div className="d-block d-xl-none">
                    <Drawer
                        touch={true}
                        transitions={true}
                        enableDragHandle={true}
                        open={drawerState}
                        onOpenChange={() => dispatch(onToggleProjectBusPriorityDrawer())}
                        sidebar={projectBusPrioritySideBar(projectBusPriority)} />
                </div>
                <div className="app-module-sidenav d-none d-xl-flex">
                    {projectBusPrioritySideBar(projectBusPriority)}
                </div>
                <div className="module-box">
                    <div className="module-box-header">
                        <span className="icon-btn drawer-btn d-flex d-xl-none"
                            onClick={() => dispatch(onToggleProjectBusPriorityDrawer())}>
                            <i className="zmdi zmdi-menu" />
                        </span>
                        <AppModuleHeader
                            placeholder="Search projectBusPriority"
                            notification={false}
                            apps={false}
                            user={projectBusPriority}
                            onChange={(event) => updatingSearchProjectBusPriority(event)}
                            value={searchProjectBusPriority} />
                    </div>
                    <div className="module-box-content">
                        <div className="module-box-topbar">
                            <div className="form-control-checkbox d-flex">
                                <div className="form-checkbox">
                                    <input type="checkbox"
                                        checked={selectedProjectBusPrioritys > 0}
                                        onChange={onAllProjectBusPrioritySelect} />
                                    <span className="check">
                                        <i className="zmdi zmdi-check zmdi-hc-lg" />
                                    </span>
                                </div>
                            </div>
                            <Button size="sm" className="jr-btn jr-flat-btn" color="default"
                                onClick={() => dispatch(onFilterSelectedProjectBusPriority())} >
                                <i className="zmdi zmdi-filter-list zmdi-hc-fw" />
                                <span><IntlMessages id="label.filter.selected" /></span>
                            </Button>
                        </div>
                        <CustomScrollbars className="module-list-scroll scrollbar"
                            style={{ height: width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)' }}>
                            {loader ?
                                <div
                                    className="loader-view-block h-100">
                                    <div className="loader-view">
                                        <CircularProgress />
                                    </div>
                                </div>
                                :
                                projectBusPriorityList && projectBusPriorityList.length > 0 ?
                                    <ProjectBusPriorityList />
                                    :
                                    <div className="h-100 d-flex align-items-center justify-content-center">
                                        {noContentFoundMessage}
                                    </div>
                            }
                        </CustomScrollbars>
                    </div>
                </div>
            </div>
            <ProjectBusPriorityAdd
                open={addProjectBusPriorityState}
            />
            {showMessage && NotificationManager.success(alertMessage, projectBusPriorityRequestClose())}
            <NotificationContainer />
        </div>
    );
};

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/projectBusPriority/component.js